export default function Contact({ data, info }) {
  const buildHeading = (heading, emphasis) =>
    heading.split(emphasis).map((part, i) => (
      <span key={i}>{part}{i === 0 && <em>{emphasis}</em>}</span>
    ));

  return (
    <section id="contact" className="contact-section">
      <div className="contact-left">
        <p className="section-label" style={{ marginBottom: 40 }}>{data.sectionLabel}</p>
        <h2>{buildHeading(data.heading, data.headingEmphasis)}</h2>
        <p>{data.intro}</p>
      </div>
      <div className="contact-right">
        <div className="contact-info-item">
          <p className="contact-info-label">Email</p>
          <p className="contact-info-value">{info.email}</p>
        </div>
        <div className="contact-info-item">
          <p className="contact-info-label">Téléphone</p>
          <p className="contact-info-value">{info.phone}</p>
        </div>
        <div className="contact-info-item">
          <p className="contact-info-label">Localisation</p>
          <p className="contact-info-value">{info.location}</p>
        </div>
        <a href={`mailto:${info.email}`} className="contact-cta">
          {data.ctaLabel} <span className="contact-cta-arrow">→</span>
        </a>
      </div>
    </section>
  );
}